import { Box, Button, Table, Text } from '@factorialco/deprecated-design-system'

import MoneyField from 'modules/core/components/MoneyField'
import TextField from 'modules/core/components/TextField'
import i18n from 'modules/core/lib/i18n'
import MoneyWithCurrency from 'modules/core/lib/money'

import { QuotePricingLineItem, profitPercentage } from 'modules/finance/components/Quotes/utils'

interface ProductRowProps {
  item: QuotePricingLineItem
  currency: string
  isDraftStatus: boolean
  locale: string
  onUpdate: (updates: Partial<QuotePricingLineItem>) => void
  onDelete: () => void
}

const ProductRow = ({
  item,
  currency,
  isDraftStatus,
  locale,
  onUpdate,
  onDelete,
}: ProductRowProps) => {
  const handleQuantityChange = (value: string) => {
    const newQuantity = Number(value)
    const currentUnitCostCents = item.unitCostCents || 0
    const currentUnitPriceCents = item.unitPriceCents || 0
    const newBaseCostCents = Math.round(newQuantity * currentUnitCostCents)
    const newBasePriceCents = Math.round(newQuantity * currentUnitPriceCents)
    const profitBaseCents = newBasePriceCents - newBaseCostCents
    onUpdate({
      quantity: newQuantity,
      baseCostCents: newBaseCostCents,
      basePriceCents: newBasePriceCents,
      baseProfitPercentage: profitPercentage(profitBaseCents, newBasePriceCents),
    })
  }

  const handleUnitCostChange = (value: string) => {
    const newUnitCostCents = Number(value) * 100
    const currentQuantity = item.quantity
    const newBaseCostCents = Math.round(currentQuantity * newUnitCostCents)
    const basePriceCents = item.basePriceCents
    const profitBaseCents = basePriceCents - newBaseCostCents
    onUpdate({
      unitCostCents: newUnitCostCents,
      baseCostCents: newBaseCostCents,
      baseProfitPercentage: profitPercentage(profitBaseCents, basePriceCents),
    })
  }

  const handleUnitPriceChange = (value: string) => {
    const newUnitPriceCents = Number(value) * 100
    const currentQuantity = item.quantity
    const newBasePriceCents = Math.round(currentQuantity * newUnitPriceCents)
    const profitBaseCents = newBasePriceCents - item.baseCostCents
    onUpdate({
      unitPriceCents: newUnitPriceCents,
      basePriceCents: newBasePriceCents,
      baseProfitPercentage: profitPercentage(profitBaseCents, newBasePriceCents),
    })
  }
  return (
    <Table.Row>
      <Table.Cell paddingX="s12" colSpan={2}>
        <Box width="s300" paddingLeft="s12">
          {isDraftStatus ? (
            <TextField
              placeholder={i18n.t('common.name')}
              value={item.description}
              onChange={(value) => onUpdate({ ['description']: value })}
            />
          ) : (
            <Text size="300" color="grey1000">
              {item.description}
            </Text>
          )}
        </Box>
      </Table.Cell>
      <Table.Cell paddingX="s12" colSpan={2}>
        <Box textAlign="right">
          {isDraftStatus ? (
            <Box flexDirection="row" justifyContent="flexEnd">
              <MoneyField
                placeholder="0"
                currency={'u'} // TODO: Translate
                onChange={handleQuantityChange}
                value={item.quantity.toString()}
              />
            </Box>
          ) : (
            <Text size="300" color="grey1000">
              {`${item.quantity} u`}
            </Text>
          )}
        </Box>
      </Table.Cell>
      <Table.Cell paddingX="s12" colSpan={2}>
        <Box textAlign="right">
          {isDraftStatus ? (
            <Box flexDirection="row" justifyContent="flexEnd">
              <MoneyField
                placeholder="0"
                currency={currency}
                onChange={handleUnitCostChange}
                value={((item.unitCostCents || 0) / 100).toString()}
              />
            </Box>
          ) : (
            <Text size="300" color="grey1000">
              {MoneyWithCurrency({
                optionalDecimals: true,
                amount: item.unitCostCents || 0,
                currency,
                locale,
              })}
            </Text>
          )}
        </Box>
      </Table.Cell>
      <Table.Cell paddingX="s12" colSpan={2}>
        <Box textAlign="right">
          {isDraftStatus ? (
            <Box flexDirection="row" justifyContent="flexEnd">
              <MoneyField
                placeholder="0"
                currency={currency}
                onChange={handleUnitPriceChange}
                value={((item.unitPriceCents || 0) / 100).toString()}
              />
            </Box>
          ) : (
            <Text size="300" color="grey1000">
              {MoneyWithCurrency({
                optionalDecimals: true,
                amount: item.unitPriceCents || 0,
                currency,
                locale,
              })}
            </Text>
          )}
        </Box>
      </Table.Cell>
      <Table.Cell paddingX="s12" colSpan={2}>
        <Box textAlign="right">
          <Text size="300" color="grey1000">
            {`${item.baseProfitPercentage}%`}
          </Text>
        </Box>
      </Table.Cell>
      <Table.Cell paddingX="s12" colSpan={2}>
        <Box textAlign="right">
          <Text size="300" color="grey1000">
            {MoneyWithCurrency({
              optionalDecimals: true,
              amount: item.baseCostCents,
              currency,
              locale,
            })}
          </Text>
        </Box>
      </Table.Cell>
      <Table.Cell paddingX="s12" colSpan={2}>
        <Box textAlign="right">
          <Text size="300" color="grey1000">
            {MoneyWithCurrency({
              optionalDecimals: true,
              amount: item.basePriceCents,
              currency,
              locale,
            })}
          </Text>
        </Box>
      </Table.Cell>
      {isDraftStatus && (
        <Table.Cell paddingX="s12" colSpan={1} width={80}>
          <Button type="secondary" iconName="delete" onClick={onDelete} />
        </Table.Cell>
      )}
    </Table.Row>
  )
}

export default ProductRow
